export enum QueryKeys {
  BRANDS = 'brands',
  USERS = 'users',
  ROLES = 'roles',
  PERMISSIONS = 'permissions',
  ADDONS = 'addons',
  EXTENSIONS = 'extensions',
}
